import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { msgSourceActions } from '_actions';
import PageContainer from 'components/v2/common/PageContainer';
import ChannelAccordionItem from './ChannelAccordionItem';
import ReconnectChannelsSection from './ReconnectChannelsSection';
import styles from './styles'
import './ListChannels.css';
import { history } from '_helpers';

// V1 Components, replace these maybe with V2 Components later
import { Loading } from 'components/common';
import BasicActionButton from "../../../../v3/common/BasicActionButton";

/**
 * Filter out the ones where `msgSources[0].msgDataSources[0].isActive` equals true or false.
 */
const getFilteredMsgSources = ({ msgSources, returnCredentialsExpired }) => {
	return msgSources?.filter(msgSource => {
		const filteredMsgDataSources = msgSource.msgDataSources?.filter(msgDataSource => {
			return msgDataSource.isCredentialsExpired === returnCredentialsExpired
		})

		if (!filteredMsgDataSources.length)
			return false

		return {
			...msgSource,
			msgDataSources: filteredMsgDataSources
		}
	})
};

const getFilteredInactiveMsgSources = ({ msgSources, returnCredentialsExpired }) => {
	return msgSources.map((msgSource) => {
		const filteredMsgDataSources = msgSource.msgDataSources?.filter(
			(msgDataSource) => msgDataSource.isCredentialsExpired === returnCredentialsExpired
		) || [];

		if (!filteredMsgDataSources.length) return null;

		return { ...msgSource, msgDataSources: filteredMsgDataSources };
	}).filter((item) => item !== null);
};

export default function ListChannels() {
	const dispatch = useDispatch()
	const _msgSourcesFromState = useSelector((state) => state.msgSources.msgSources)
	const loading = useSelector((state) => state.msgSources.loading)

	const msgSources = useMemo(() => getFilteredMsgSources({ msgSources: _msgSourcesFromState ?? [], returnCredentialsExpired: false }), [_msgSourcesFromState])
	const msgSourcesInactive = useMemo(() => getFilteredInactiveMsgSources({ msgSources: _msgSourcesFromState ?? [], returnCredentialsExpired: true }), [_msgSourcesFromState])

	useEffect(() => {
		// Dispatch `getAll` to fetch all msgSources into state.
		const currentUser = JSON.parse(localStorage.user);
		const organizationId = currentUser._embedded.organization.id;
		dispatch(msgSourceActions.getAll({ organizationId: organizationId }))
	}, [])

	if (loading)
		return <Loading />

	return (
		<PageContainer backgroundColor={'#edede4'}>
			<Box sx={{...styles.headingBox, marginTop: '-2px'}}>
				<Box component={'h1'} sx={{m: 0, fontFamily: 'IvyPrestoHeadlineRegular', fontSize: '50px', color: '#0C2728', height: '45px', lineHeight: 0.8}}>
					Channels
				</Box>
				<Box sx={{marginTop: '2px'}}>
					<BasicActionButton label={'Connect new channel'} action={() => history.push('/company/connectchannels')} />
				</Box>
			</Box>

			{(msgSources && msgSources.length) ? (
				<Box sx={{ ...styles.card, mt: { xs: 4, sm: 6 }}}>
					<Box sx={styles.cardHeader}>
						Currently connected ({msgSources.length})
					</Box>
					{ msgSources.map((msgSource, key) => (
						<ChannelAccordionItem
							msgSource={msgSource}
							key={msgSource.id}
							keyNumber={key}	
						/>
					)) }
				</Box>
			) : null}

			{(msgSourcesInactive && msgSourcesInactive.length) ? (
				<ReconnectChannelsSection msgSourcesInactive={msgSourcesInactive} />
			) : null}
		</PageContainer>
	)
}

